export default __webpack_public_path__ + "static/media/school-two.d2a94802.png";